import { nFormatter } from "../utils/utils";
import { validCountries } from "../global/validCountries";
import find from "lodash/find";
import { countriesLatLng } from "../global/contriesLatLng";

export class GeoMap {
  constructor(code, iso2, name, total, actual, percent, color, latitude, longitude) {
    this.code = code;
    this.iso2 = iso2;
    this.name = name;
    this.total = total * 1;
    this.totalText = nFormatter(total, 1, "$");
    this.totalTextRaw = "$" + total;
    this.actual = actual * 1;
    this.actualText = nFormatter(actual, 1, "$");
    this.actualTextRaw = "$" + actual * 1;
    this.untap = total * 1 - actual * 1;
    this.untapText = this.untap >= 0 ? nFormatter(this.untap, 1, "$") : "-";
    this.untapTextRaw = this.untap >= 0 ? "$" + this.untap * 1 : "-";
    this.percent = percent;
    this.percentText = (percent * 100).toFixed(2);
    this.color = color;
    this.latitude = latitude;
    this.longitude = longitude;
  }

  static fromApiObject(input) {
    if (typeof (input) === "object" && input !== null) {
      let iso = ""
      var geo = { latitude: "", longtitude: "" }
      try {
        iso = find(validCountries.data, function (o) { return o.code * 1 === input.ItemCode * 1; }).iso2;
        geo = find(countriesLatLng.data, function (o) { return o.iso2 === iso; });
      } catch (error) {
        console.error(error);
      }
      return new GeoMap(input.ItemCode, iso, input.Item.Name, input.Value, input.ExportValue, input.RealizedPotential, input.Item.Parent.Color, geo ? geo.latitude : "", geo ? geo.longitude : "")
    }
    return new GeoMap();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => GeoMap.fromApiObject(item));
    }
    if (typeof (input) === "object" && input !== null) {
      return [GeoMap.fromApiObject(input)];
    }
    return [];
  }
}